import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { sub } from "date-fns";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject, Observable } from "rxjs";
import { OrderByPipe } from "valuchaincommon/shared-components/order-by/order-by.pipe";
import { StoresService } from "../catalog/stores.service";
import { UpdateAppointmentProductsService } from "../inventory/update-appointment-products-service";
import { LiveshopService } from "../liveshop/liveshop.service";
import { SlotService } from "../slot/slot.service";
import { GetVideoCallDataService } from "../video-call/get-video-call-data.service";
import { DialogService } from "../dialog-service/dialog.service";
import { ProfileComponent } from "src/app/features/user/profile/profile.component";
import { LocalStorageService } from "src/app/services/shared/local-storage/local-storage.service";
@Injectable({
  providedIn: "root",
})
export class PromolinkAuthorizationService {
  appointmentData;
  promoLinkData;
  checkLinkData;
  orderLinkData;
  closeMobileRedirectDialog = new BehaviorSubject(false);
  isInitialDataLoaded: BehaviorSubject<boolean> = new BehaviorSubject(false);
  threedDashboardReload = new BehaviorSubject(false);
  showWhatsAppRedirectionTemplate = false;
  selectionBoardLoaded = false;

  constructor(
    private getVideoCallDataService: GetVideoCallDataService,
    private slotService: SlotService,
    private liveshopService: LiveshopService,
    private updateAppointmentProductsService: UpdateAppointmentProductsService,
    private toastrService: ToastrService,
    private router: Router,
    private storesService: StoresService,
    public localStorageService: LocalStorageService,
    public dialogService: DialogService
  ) {}

  getCartValueData(res, data, sub, isLoggedInUser, isReload?) {
    this.slotService.rectangleSetting =
      res.appointment.owner.businessUnit.settings.whiteshop.isRectangleTemplate;
    this.appointmentData = res;
    this.liveshopService.code = this.appointmentData.appointment.code;
    this.updateAppointmentProductsService.gradesList =
      res.appointment.owner.businessUnit.settings.whiteshop.gradeDefinition;
    this.slotService.appointmentCode = this.liveshopService.code;
    this.updateAppointmentProductsService.bussinessUnitSettings = this.appointmentData.appointment.owner.businessUnit.settings;
    this.liveshopService.appointmentDetails = this.appointmentData.appointment;
    this.updateAppointmentProductsService.isCartTypes = this.slotService.isCartTypes(
      this.appointmentData.appointment.owner.businessUnit
    );
    if (
      !(
        data.data.orderLink.status === "Expired" ||
        data.data.orderLink.status === "Completed"
      )
    ) {
      sub.next(this.appointmentData);
    }
    localStorage.setItem(
      "currentCompanyId",
      this.appointmentData?.appointment?.owner?.company?._id
    );
    if (
      this.appointmentData.appointment.owner.businessUnit.settings &&
      this.appointmentData.appointment.owner.businessUnit.settings
        .appointment &&
      this.appointmentData.appointment.owner.businessUnit.settings.appointment
        .isInventoryGroupNumberOfUnits &&
      this.appointmentData.appointment.owner.businessUnit.settings.appointment
        .classifications
    ) {
      this.updateAppointmentProductsService.cartTypes = this.appointmentData.appointment.owner.businessUnit.settings.appointment.classifications;
    }
    if (
      this.updateAppointmentProductsService.cartTypes &&
      this.updateAppointmentProductsService.cartTypes.length
    ) {
      this.updateAppointmentProductsService.cartTypes = OrderByPipe.prototype.transform(
        this.updateAppointmentProductsService.cartTypes,
        ["sequence"]
      );
    }
    this.liveshopService.conf =
      this.appointmentData.appointment?.companyConfig?.isProductInventory ||
      this.appointmentData.appointment?.companyConfig?.whiteshop
        ?.isProductInventory;
    if (localStorage.getItem("user")) {
      if (this.appointmentData.appointment?.products) {
        this.updateAppointmentProductsService.cartRes.next(
          this.appointmentData.appointment.products
        );
      }
      if (this.liveshopService.conf) {
        this.liveshopService.response_cart = this.appointmentData.appointment.products
          .filter((each) => each.inventoryGroup)
          .map((item) => {
            item.inventories.forEach((eachInventory) => {
              eachInventory.manageStock = item.inventoryGroup.manageStock;
              eachInventory.allowOutOfStockPurchase =
                item.inventoryGroup.allowOutOfStockPurchase;
            });
            this.liveshopService.aggregated[item.inventoryGroup._id] =
              item.inventories;
          });
        this.liveshopService.aggregated[
          "instantProducts"
        ] = this.appointmentData.appointment.products.filter(
          (eachProduct) => eachProduct?.productCategoryData
        );
      }
    }
    if (
      data.data.orderLink.status === "Expired" ||
      data.data.orderLink.status === "Completed"
    ) {
      this.toastrService.error("Link is " + data.data.orderLink.status, null, {
        timeOut: 2000,
      });

      setTimeout(() => {
        if (isLoggedInUser) {
          this.router.navigateByUrl("/myorders").then(() => {
            window.location.reload();
          });
        } else {
          this.router.navigateByUrl("/homePage").then(() => {
            window.location.reload();
          });
        }
      }, 1000);
    } else {
      data["isLoggedInUser"] = isLoggedInUser;
      // this.getPromoLinkData(data);
    }
  }

  getCartDataValue(data, sub, isReload?) {
    localStorage.removeItem("shortLinkData");
    const isLoggedInUser =
      localStorage.getItem("retailerToken") ||
      localStorage.getItem("nVipaniwhiteshopUser");
    if (isReload) {
      this.appointmentData = JSON.parse(
        sessionStorage.getItem("promoLinkAppointmentData")
      ).appointmentData;
      this.getCartValueData(
        this.appointmentData,
        data,
        sub,
        isLoggedInUser,
        isReload
      );
    } else {
      this.getVideoCallDataService
        .getVideoCallData(
          data.data.orderLink.appointmentData.code,
          isLoggedInUser ? "" : "external",
          true,
          isLoggedInUser ? "" : data.email,
          data.data.typeName !== "Inseason" ||
            (data.data.typeName === "Inseason" &&
              data.data.status !== "Completed")
            ? true
            : undefined,
          isLoggedInUser ? "" : data.mobile
        )
        .subscribe(
          (res) => {
            this.getCartValueData(res, data, sub, isLoggedInUser, isReload);
          },
          (err) => {
            if (err.error.message !== "Session expired.") {
              this.toastrService.error(err.error.message, null, {
                timeOut: 2000,
              });
              if (err.error.message.startsWith("Not authorized")) {
                if (localStorage.getItem("retailerToken")) {
                  this.localStorageService.logout();
                }
              }
            }
            console.log(err.error.message);
          }
        );
    }
  }

  getCartData(data, isReload?, isInitial?) {
    this.slotService.removePaymentModesAndTerms(data);
    if (!isReload) {
      this.checkLinkData = data;
    }
    const observable = new Observable((sub) => {
      this.getCartDataValue(data, sub, isReload);
    });
    observable.subscribe((result) => {
      this.getPromoLinkData(data, isReload, isInitial);
    });
  }

  getPromoLinkData(data, isReload?, isInitial?) {
    const promoLinkData = {
      cartData: this.appointmentData.appointment.products,
      code: this.appointmentData.appointment.code,
      settings: this.appointmentData.appointment.owner.businessUnit.settings,
      buyerImage:
        this.appointmentData &&
        this.appointmentData.appointment &&
        this.appointmentData.appointment.companyConfig &&
        this.appointmentData.appointment.companyConfig.companyLogo
          ? this.appointmentData.appointment.companyConfig.companyLogo
          : null,
      sellerImage: data.data.orderLink.owner.businessUnit.brandImage
        ? data.data.orderLink.owner.businessUnit.brandImage
        : null,
      selfUser: {
        value: this.appointmentData.appointment.value,
      },
      spot: true,
      isSpotB2B: true,
      appointmentProducts: this.appointmentData.appointment.appointmentProducts,
      inventoryGroupSets: data.data.orderLink.inventoryGroupSets,
      orderLink: data.data.orderLink.code,
      status: data.data.orderLink.status,
      data: data.data.orderLink,
      productOrderLinkData: data.data,
      casePackImage:
        this.appointmentData.appointment.owner.businessUnit.settings.whiteshop
          .orderLink &&
        this.appointmentData.appointment.owner.businessUnit.settings.whiteshop
          .orderLink[1] &&
        this.appointmentData.appointment.owner.businessUnit.settings.whiteshop
          .orderLink[1].casePackImage
          ? this.appointmentData.appointment.owner.businessUnit.settings
              .whiteshop.orderLink[1].casePackImage
          : undefined,
      currentUser: this.liveshopService.appointmentDetails.user,
    };
    if (data.email) {
      promoLinkData.selfUser["email"] = data.email;
      promoLinkData["email"] = data.email;
    }
    if (data.mobile) {
      promoLinkData.selfUser["mobile"] = data.mobile;
      promoLinkData["mobile"] = data.mobile;
      if (!data.email) {
        promoLinkData.selfUser["name"] = data.mobile;
      }
    }
    promoLinkData.selfUser["name"] = data.name
      ? data.name
      : data.displayName
      ? data.displayName
      : data.email;

    this.liveshopService.currentUser = promoLinkData.selfUser;

    promoLinkData["businessUnitId"] =
      data.data.orderLink.owner.businessUnit._id;
    if (data.isLoggedInUser) {
      if (isReload) {
        this.orderLinkData = JSON.parse(
          sessionStorage.getItem("promoLinkAppointmentData")
        ).orderLinkData;
        this.openPromoLink(
          this.orderLinkData,
          data,
          promoLinkData,
          isReload,
          isInitial
        );
      } else {
        this.slotService.getOrderLinkData(promoLinkData.orderLink).subscribe(
          (res) => {
            this.orderLinkData = res;
            this.openPromoLink(res, data, promoLinkData, isReload, isInitial);
          },
          (err) => {
            this.toastrService.error(err.error.message, null, {
              timeOut: 2000,
            });
            window.location.href = location.origin;
          }
        );
      }
    } else {
      if (isReload) {
        this.orderLinkData = JSON.parse(
          sessionStorage.getItem("promoLinkAppointmentData")
        ).orderLinkData;
        this.openPromoLink(
          this.orderLinkData,
          data,
          promoLinkData,
          isReload,
          isInitial
        );
      } else {
        if (
          localStorage.getItem("userGroup") &&
          (JSON.parse(localStorage.getItem("userGroup")).name === "Admin" ||
            JSON.parse(localStorage.getItem("userGroup")).name === "Manager" ||
            JSON.parse(localStorage.getItem("userGroup")).name === "Employee")
        ) {
          this.slotService
            .getCustomerOrderLinkData(promoLinkData.orderLink)
            .subscribe(
              (res) => {
                this.orderLinkData = res;
                this.openPromoLink(
                  res,
                  data,
                  promoLinkData,
                  isReload,
                  isInitial
                );
              },
              (err) => {
                this.toastrService.error(err.error.message, null, {
                  timeOut: 2000,
                });
                window.location.href = location.origin;
              }
            );
        } else {
          this.slotService
            .getCustomerOrderLinkData(
              promoLinkData.orderLink,
              promoLinkData.selfUser["email"],
              promoLinkData.selfUser["mobile"]
            )
            .subscribe(
              (res) => {
                this.orderLinkData = res;
                this.openPromoLink(
                  res,
                  data,
                  promoLinkData,
                  isReload,
                  isInitial
                );
              },
              (err) => {
                this.toastrService.error(err.error.message, null, {
                  timeOut: 2000,
                });
                this.showWhatsAppRedirectionTemplate = true;
                this.slotService.isPanoramaLoaded = true;
              }
            );
        }
      }
    }
  }
  openPromoLink(linkData, data, promoLinkData, isReload?, isInitial?) {
    if (linkData?.orderLink?.inventoryGroupSets) {
      linkData.orderLink.inventoryGroupSets = this.storesService.filterBoardList(
        linkData.orderLink.inventoryGroupSets
      );
    }
    if (
      !linkData?.orderLink?.inventoryGroupSets?.length &&
      !linkData?.inventoryGroupSetGroups?.length
    ) {
      this.toastrService.error("No orderlink data", null, {
        timeOut: 2000,
      });
      if (
        localStorage.getItem("userGroup") &&
        (JSON.parse(localStorage.getItem("userGroup")).name === "Admin" ||
          JSON.parse(localStorage.getItem("userGroup")).name === "Manager" ||
          JSON.parse(localStorage.getItem("userGroup")).name === "Employee")
      ) {
        window.location.href = location.origin;
      } else {
        this.showWhatsAppRedirectionTemplate = true;
        this.slotService.isPanoramaLoaded = true;
      }
    } else {
      let orderLinkData;
      if (linkData?.orderLink?.inventoryGroupSets?.length) {
        const inventoryGroupSetsID = linkData.orderLink.inventoryGroupSets.map(
          (each) => {
            return each._id;
          }
        );
        if (data?.data?.orderLink?.inventoryGroupSets) {
          data.data.orderLink.inventoryGroupSets = data.data.orderLink.inventoryGroupSets.filter(
            (each) => {
              if (each.inventoryGroupSet?._id) {
                return inventoryGroupSetsID.includes(
                  each.inventoryGroupSet._id
                );
              }
            }
          );
        }
        linkData.orderLink.inventoryGroupSets.forEach((element) => {
          let inventoryIndex = data.data.orderLink.inventoryGroupSets.findIndex(
            (set) => set.inventoryGroupSet._id === element._id
          );
          if (inventoryIndex > -1) {
            element.sequence =
              data.data.orderLink.inventoryGroupSets[inventoryIndex].sequence;
          }
        });
        orderLinkData = linkData;
        if (orderLinkData && orderLinkData.groups) {
          const index = orderLinkData.groups.gradeDefinition.findIndex(
            (each) => each.name === "Discount"
          );
          if (index > -1) {
            orderLinkData.groups.gradeDefinition.splice(index, 1);
          }
          orderLinkData.groups.inventoryGroups = orderLinkData.groups.inventoryGroups.filter(
            (each) => !each.archive && !each.deleted && !each.disabled
          );
        }
        this.liveshopService.viewProducts = this.liveshopService.getProducts(
          promoLinkData
        );
        this.slotService.collectionsList =
          orderLinkData.orderLink.inventoryGroupSets;
        this.slotService.collectionsList.sort((a, b) => {
          return a.sequence - b.sequence;
        });
        const url = new URL(window.location.href);
        const params = url.searchParams;
        let collectionId = params.get("collectionId");
        if (collectionId) {
          const selectedIndex = this.slotService.collectionsList.findIndex(
            (board) => collectionId === board._id
          );
          if (selectedIndex > -1) {
            this.slotService.selectedCollectionID =
              orderLinkData.orderLink.inventoryGroupSets[selectedIndex]?._id;
            this.slotService.selectedCollection =
              orderLinkData.orderLink.inventoryGroupSets[selectedIndex];
          }
        } else {
          this.slotService.selectedCollectionID =
            orderLinkData.orderLink.inventoryGroupSets[0]?._id;
          this.slotService.selectedCollection =
            orderLinkData.orderLink.inventoryGroupSets[0];
        }
      }
      let user;
      if (localStorage.getItem("nVipaniwhiteshopkey")) {
        user = JSON.parse(localStorage.getItem("user"));
        user.name = user.displayName;
        this.liveshopService.currentUser = user;
      }
      this.promoLinkData = {
        isSelections: true,
        selfUser: promoLinkData.selfUser,
        isLoggedInUser:
          (user && user.type === "B2B") ||
          localStorage.getItem("retailerToken"),
        buyerImage: promoLinkData.data.logo || false,
        inventoryGroups:
          orderLinkData &&
          orderLinkData.groups &&
          orderLinkData.groups.inventoryGroups
            ? orderLinkData.groups.inventoryGroups
            : [],
        data: data.data.orderLink,
        currentUser: this.liveshopService.appointmentDetails.user,
        companyName: this.appointmentData.appointment.owner.company.name,
      };
      this.slotService.currentPromoLinkData = this.promoLinkData;
      if (!isReload || isInitial) {
        let promoLinkAppointmentData = {
          appointmentData: this.appointmentData,
          checkLinkData: this.checkLinkData,
          orderLinkData: orderLinkData,
        };
        sessionStorage.setItem(
          "promoLinkAppointmentData",
          JSON.stringify(promoLinkAppointmentData)
        );
        sessionStorage.setItem("promoLinkData", JSON.stringify(promoLinkData));
        if (!isInitial) {
          if (
            localStorage.getItem("threedReload") &&
            window.location.href.includes("stores/promolink")
          ) {
            this.threedDashboardReload.next(true);
          } else {
            localStorage.removeItem("threedReload");
            if (
              this.checkLinkData.data.orderLink.boardTypeName === "board groups"
            ) {
              this.slotService.currentPromoLinkData = this.promoLinkData;
              this.router.navigateByUrl(
                "/stores/boardGroupPromolink" +
                  window.location.href.split(
                    window.location.origin + "/promolink"
                  )[1]
              );
            } else {
              this.router.navigateByUrl(
                "/stores/promolink" +
                  window.location.href.split(
                    window.location.origin + "/promolink"
                  )[1]
              );
            }
          }
        } else {
          this.isInitialDataLoaded.next(true);
        }
        this.closeMobileRedirectDialog.next(true);
      }
    }
  }
  handlePromoLinkError(err) {
    if (
      (err && err.error && err.error.message === "Appointment is Deleted") ||
      err.error.message === "Appointment is Disabled"
    ) {
      this.toastrService.error("No promotion link found", null, {
        timeOut: 2000,
      });
      window.location.replace(window.location.origin);
    }
  }

  goToMyProfile() {
    let addDialog;
    if (window.innerWidth < 450 || window.innerHeight < 550) {
      addDialog = {
        width: "100vw",
        minWidth: "100vw",
        height: "100Vh",
        minHeight: "100vh",
      };
    } else if (window.innerWidth < 1100) {
      addDialog = {
        width: "45vh",
        minWidth: "450px",
        height: "55vh",
        minHeight: "500px",
        maxHeight: "620px",
      };
    } else {
      addDialog = {
        width: "36vw",
        minWidth: "450px",
        height: "83vh",
        minHeight: "450px",
        maxHeight: "500px",
      };
    }
    const myDialogRef = this.dialogService.openMatDialog(
      ProfileComponent,
      null,
      null,
      addDialog
    );
    myDialogRef.afterClosed().subscribe((data) => {
      if (data) {
        const user = JSON.parse(localStorage.getItem("user"));
        user.profileImageURL = data.profileImageURL;
        user.displayName = data.displayName;
        localStorage.setItem("user", JSON.stringify(user));
        this.localStorageService.islocalStorageUpdated.next(true);
        this.liveshopService.currentUser = user;
      }
    });
  }
}
